'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = EventBuilder;

function addClientNameProperty(properties, clientName) {
  if (clientName === undefined) return properties;
  return Object.assign({
    client_name: clientName
  }, properties);
}

function addCurrentPageProperty(properties) {
  var href = window.location.href;
  return Object.assign({
    current_page: href
  }, properties);
}

function previousPage() {
  var _window = window,
      locations = _window.locations;
  return locations.length > 1 ? locations[locations.length - 2] : '/';
}

function addPageViewProperties(properties) {
  var _window2 = window,
      _window2$location = _window2.location,
      pathname = _window2$location.pathname,
      hostname = _window2$location.hostname;
  var prevPage = previousPage();
  return Object.assign({
    page: pathname,
    domain: hostname,
    previous_page: prevPage
  }, properties);
}

function pushCurrentLocation() {
  var pathname = window.location.pathname; // get window.locations value if it has been set on previous push

  var locations = window.locations ? window.locations : [];
  locations.push(pathname);
  window.locations = locations;
}

function EventBuilder(_ref) {
  var name = _ref.name,
      customProperties = _ref.customProperties,
      clientName = _ref.clientName;
  if (typeof window === 'undefined') return;

  if (typeof name === 'undefined') {
    throw 'Undefined event name';
  }

  var cb = Math.random();
  var properties = addClientNameProperty(customProperties, clientName);

  if (name === 'link_click' || name === 'button_press') {
    properties = addCurrentPageProperty(properties);
  }

  if (name === 'page_view') {
    pushCurrentLocation();
    properties = addPageViewProperties(properties);
  }

  return {
    event: {
      name: name,
      properties: properties,
      cb: cb
    }
  };
}